import { render, staticRenderFns } from "./events.vue?vue&type=template&id=5abb64f6&scoped=true"
import script from "./js/event.js?vue&type=script&lang=js&external"
export * from "./js/event.js?vue&type=script&lang=js&external"
import style0 from "./events.vue?vue&type=style&index=0&id=5abb64f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb64f6",
  null
  
)

export default component.exports